<template>
  <ym-loadmore v-if="list.length > 0"
               class="review-list"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <item v-for="item in list"
          :key="item.id"
          :user="item.user"
          :rate="item.rating"
          :content="item.content"
    />
  </ym-loadmore>
  <div v-else
       class="empty"
  >
    暂无评价
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import Item from '@/pages/Review/components/ReviewItem';
  import { getReviewList } from '@/services/review';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'ReviewList',
    components: {
      'ym-loadmore': Loadmore,
      Item,
    },
    props: {
      reviews: {
        type: Array,
        required: true,
      },
      nextStart: {
        type: Number,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
      };
    },
    watch: {
      reviews(val) {
        this.list = val;
      },
      nextStart(val) {
        this.start = val;
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;

        this.loading = true;

        const data = await getReviewList({
          targetType: this.targetType,
          targetId: this.targetId,
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
    },
    created() {
      this.list = this.reviews;
      this.start = this.nextStart;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
